import { jwtDecode } from 'jwt-decode';

import { authDBService } from '~/services';
import { showAuthExpiredDialog } from '~/utils/auth';

import { type TypeLogisticsType, type TypeOwnerType } from '~/constants/common';

import { TypeUserClass } from '~/types/common.types';

export type TypeDecodedToken = {
  loginId: string;
  name: string;
  ownerCode: string;
  ownerName: string;
  ownerType: TypeOwnerType;
  logisticsTypes: TypeLogisticsType[];
  userClass: TypeUserClass;
};

const getDecodedJwtValue = async () => {
  try {
    const loginInfo = await authDBService.getLoginInfo();
    const token = loginInfo?.access_token;

    const decodedJwtValue = jwtDecode<TypeDecodedToken>(token ?? '');

    return decodedJwtValue;
  } catch {
    showAuthExpiredDialog();
  }
};

export default getDecodedJwtValue;
